import { DashboardGroupSubMenu } from '../components/DashboardGroupSubMenu'

/**
 * MobieTrain Insights — planned shell.
 *
 * Keep this route intentionally minimal until the integration is real: the page
 * shows only its title and the same grey Planned badge as the other pending
 * Insights cards. No embed token, setup guidance or placeholder dashboard.
 */
export function InsightsEmbedPage() {
  return (
    <div id="mobietrain-panel" className="space-y-4">
      <DashboardGroupSubMenu
        activeKey="mobietrain_insights"
        fallbackGroupKey="insights"
        panelId="mobietrain-panel"
      />

      <section className="card space-y-3 p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="space-y-1">
            <h2 className="text-sm font-semibold text-slate-900 dark:text-white">
              MobieTrain Insights
            </h2>
            <p className="text-xs leading-relaxed text-slate-600 dark:text-slate-400">
              Who has completed their training and who has not, completion % and expiring
              certificates.
            </p>
          </div>
          <span className="badge shrink-0 bg-slate-500/15 text-slate-600 dark:text-slate-300">
            Planned
          </span>
        </div>
        <button
          type="button"
          disabled
          aria-disabled="true"
          className="inline-flex cursor-not-allowed items-center justify-center rounded-lg border border-transparent px-2 py-1.5 text-xs font-semibold text-slate-400 dark:text-slate-500"
        >
          Coming soon
        </button>
      </section>
    </div>
  )
}
